<template>
    <nav>
        <ul class="pagination justify-content-center">
            <li
                class="page-item"
                :class="{ disabled: currentPage === 1 }"
            >
                <a
                    class="page-link"
                    href="#"
                    @click.prevent="goToPage(currentPage - 1)"
                >
                    Précédent
                </a>
            </li>

            <li
                v-for="(paginate, key) of paginates"
                :key="key"
                class="page-item"
                :class="{ active: currentPage === paginate , disabled: paginate === '...'}"
            >
                <a
                    class="page-link"
                    href="#"
                    @click.prevent="goToPage(paginate)"
                >
                    {{ paginate }}
                </a>
            </li>

            <li
                class="page-item"
                :class="{ disabled: currentPage === lastPage }"
            >
                <a
                    class="page-link"
                    href="#"
                    @click.prevent="goToPage(currentPage + 1)"
                >
                    Suivant
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
    export default {
        name: "BasePaginate",

        props: {
            currentPage: {type: Number, required: true},
            lastPage: {type: Number, required: true}
        },

        computed: {
            /**
             * Retourne la valeur du milieu de la pagination
             */
            paginateMiddle: function() {
                if (this.currentPage < 4) {
                    return 4
                } else if (this.currentPage > this.lastPage - 4 && this.lastPage > 6) {
                    return this.lastPage - 3
                }
                return this.currentPage
            },

            /**
             * Calcul la liste des pages de la pagination
             */
            paginates: function () {
                let j = this.lastPage > 7 ? this.paginateMiddle - 3 : 1
                let paginates = []

                // Créé la liste de pagination autour du paginateMiddle
                for (let i = 0;  i < 7 && j <= this.lastPage; i++, j++) {
                    paginates.push(j)
                }

                // Utilise "..." pour accéder à la première et dernière page
                if (this.lastPage > 7) {
                    if (this.paginateMiddle > 4) {
                        paginates[0] = 1
                        paginates[1] = '...'
                    }

                    if (this.paginateMiddle < this.lastPage - 3) {
                        paginates[6] = this.lastPage
                        paginates[5] = '...'
                    }
                }

                return paginates
            }
        },

        methods: {
            /**
             * Émet un évènement de changement de page
             */
            goToPage: function (pageNumber) {
                this.$emit('change-page', pageNumber)
            }
        }
    }
</script>
